module.exports = __webpack_public_path__ + "img/invest-page-escalator-bg.0c65c7a2.png";